<template>
  <zen-one :showuserinfo="false" :title="'Welcome to ' + $page.props.app_name">
    
    <z-animate-number value="29"></z-animate-number>


    <w-flex class="grow justify-space-betweenx basis-zero">
      
        <z-dashboard-item 
        class="box mb3 mr3" 
        :use-icon="false" 
        :use-slot="true" 
        >



          <template #zdileftbox>
            <div style="height:180px;width: 100%; display: flex;flex-direction:column;">
            <div class="dashboard-title">Kutipan Hasil </div> 
            <div class="dashboard-subtitle mt1 mb3">Mengikut Daerah Berdasarkan Anggaran & Tunggakan</div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 

            <vue3-chart-js class="mr3"
                :id="daylyChart.id"
                :type="daylyChart.type"
                :data="daylyChart.data"
                :options="daylyChart.options"
                @before-render="beforeRenderLogic"
            ></vue3-chart-js>
            </div>
          </template>

        </z-dashboard-item>

        <z-dashboard-item
        class="box mb3 mr3" 
        :use-icon="false" 
        :use-slot="true" 
        >
            <div class="dashboard-title">Kutipan Hasil </div>
            <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada Hari Ini</div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 

            <table style="width:100%" class="mb2 table-dashboard">
              
                <thead >
                <tr>
                  <td width="20%">Tahun</td>
                  <td width="20%">
                      <i class="w-icon fal fa-search size--sm mr2" role="icon" aria-hidden="true"></i>
                      Anggaran (RM)
                  </td>
                  <td width="20%">
                      <i class="w-icon fal fa-dollar-sign size--sm mr2" role="icon" aria-hidden="true"></i>
                      Kutipan (RM)</td>
                  <td width="20%">
                      <i class="mr1 fal fa-chart-line size--sm mr2"></i>
                      Peratus (%)
                  </td>
                  <td width="20%">Perbezaan Peratus (%)</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Hari Ini</td>
                  <td><b>RM</b> 501,694,290.00</td>
                  <td><b>RM</b> 474,755,207.41</td>
                  <td>94.63 <b>%</b></td>
                  <td colspan="1" rowspan="2">29.89</td>
                </tr>
                <tr>
                  <td>Semalam</td>
                  <td><b>RM</b> 499,000,000.00</td>
                  <td><b>RM</b> 323,064,810.26</td>
                  <td>64.74 <b>%</b></td>
                </tr>
                <tr>
                  <td colspan="2" rowspan="1"><b>Peningkatan Jumlah Kutipan</b></td>
                  <td colspan="3" rowspan="1"><b>RM</b> 151,690,397.15</td>
                </tr>
              </tbody>
            </table>
        </z-dashboard-item>

        <z-dashboard-item 
        class="box mb3" 
        :use-icon="false" 
        :use-slot="true" 
        >

          <template #zdileftbox>
            <div style="height:180px;width: 100%; display: flex;flex-direction:column;">
            <div class="dashboard-title">Kaedah Kutipan Hasil </div> 
            <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada Hari Ini </div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 
            <vue3-chart-js class="mr3"
                :id="transactionmethoddaylyChart.id"
                :type="transactionmethoddaylyChart.type"
                :data="transactionmethoddaylyChart.data"
                :options="transactionmethoddaylyChart.options"
                @before-render="beforeRenderLogic"
            ></vue3-chart-js>
            </div>
          </template>

        </z-dashboard-item>


    </w-flex>


    <w-flex class="grow justify-space-betweenx basis-zero">
      
        <z-dashboard-item 
        class="box mb3 mr3" 
        :use-icon="false" 
        :use-slot="true" 
        >



          <template #zdileftbox>
            <div style="height:180px;width: 100%; display: flex;flex-direction:column;">
            <div class="dashboard-title">Kutipan Hasil </div> 
            <div class="dashboard-subtitle mt1 mb3">Sepanjang Tahun 2021 Berdasarkan Anggaran dan Kutipan</div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 

            <vue3-chart-js class="mr3"
                :id="monthlyChart.id"
                :type="monthlyChart.type"
                :data="monthlyChart.data"
                :options="monthlyChart.options"
                @before-render="beforeRenderLogic"
            ></vue3-chart-js>
            </div>
          </template>

        </z-dashboard-item>

        <z-dashboard-item
        class="box mb3 mr3" 
        :use-icon="false" 
        :use-slot="true" 
        >
            <div class="dashboard-title">Kutipan Hasil </div> 
            <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada tahun 2020 dan 2021</div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 

            <table style="width:100%" class="mb2 table-dashboard">
              
                <thead >
                <tr>
                  <td width="20%">Tahun</td>
                  <td width="20%">
                      <i class="w-icon fal fa-search size--sm mr2" role="icon" aria-hidden="true"></i>
                      Anggaran (RM)
                  </td>
                  <td width="20%">
                      <i class="w-icon fal fa-dollar-sign size--sm mr2" role="icon" aria-hidden="true"></i>
                      Kutipan (RM)</td>
                  <td width="20%">
                      <i class="mr1 fal fa-chart-line size--sm mr2"></i>
                      Peratus (%)
                  </td>
                  <td width="20%">Perbezaan Peratus (%)</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>2021</td>
                  <td><b>RM</b> 501,694,290.00</td>
                  <td><b>RM</b> 474,755,207.41</td>
                  <td>94.63 <b>%</b></td>
                  <td colspan="1" rowspan="2">29.89</td>
                </tr>
                <tr>
                  <td>2020</td>
                  <td><b>RM</b> 499,000,000.00</td>
                  <td><b>RM</b> 323,064,810.26</td>
                  <td>64.74 <b>%</b></td>
                </tr>
                <tr>
                  <td colspan="2" rowspan="1"><b>Peningkatan Jumlah Kutipan</b></td>
                  <td colspan="3" rowspan="1"><b>RM</b> 151,690,397.15</td>
                </tr>
              </tbody>
            </table>
        </z-dashboard-item>

        <z-dashboard-item 
        class="box mb3" 
        :use-icon="false" 
        :use-slot="true" 
        >

          <template #zdileftbox>
            <div style="height:180px;width: 100%; display: flex;flex-direction:column;">
            <div class="dashboard-title">Kutipan Hasil </div> 
            <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada tahun 2020 dan 2021</div>
            <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> 
            <vue3-chart-js class="mr3"
                :id="doughnutChart.id"
                :type="doughnutChart.type"
                :data="doughnutChart.data"
                :options="doughnutChart.options"
                @before-render="beforeRenderLogic"
            ></vue3-chart-js>
            </div>
          </template>

        </z-dashboard-item>


    </w-flex>

    <!-- 1row -->
    <w-flex class="grow justify-space-betweenx basis-zero">

    <z-dashboard-item 
      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"

      image="/images/map/kota-setar-1.png" 
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">242.40 %</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Kota Setar</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb3">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
        Anggaran : <br>
        RM 38,292,640.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
        Kutipan : <br>
        RM 92,822,588.80
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/kuala-muda-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">131.58%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Kuala Muda</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 102,593,630.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 72,428,358.47
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/kubang-pasu-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">68.79%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Kubang Pasu</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 37,513,870.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 25,807,087.29
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 dashboard-box" 
      :use-icon="false"
      image="/images/map/langkawi-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">67.06%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Langkawi</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 122,146,260.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 81,910,399.21
      </w-tag>
    </z-dashboard-item>

    </w-flex>
    <!--/1row -->

    <!-- 2row -->
    <w-flex class="grow justify-space-betweenx basis-zero">

    <z-dashboard-item 
      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"

      image="/images/map/kulim-1.png" 
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">57.67%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Kulim</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb3">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
        Anggaran : <br>
        RM 73,536,980.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
        Kutipan : <br>
        RM 42,405,711.94
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/sik-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">131.58%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Sik</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 21,838,580.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 28,734,748.01
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/yan-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">89.68%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Yan</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 4,607,990.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 4,132,466.52
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 dashboard-box" 
      :use-icon="false"
      image="/images/map/padang-terap-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">76.07%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Padang Terap</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 17,108,640.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 13,015,180.21
      </w-tag>
    </z-dashboard-item>

    </w-flex>
    <!--/2row -->

    <!-- 3row -->
    <w-flex class="grow justify-space-betweenx basis-zero">

    <z-dashboard-item 
      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"

      image="/images/map/bandar-baharu-1.png" 
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">72.14%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Bandar Baharu</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb3">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">A</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
        Anggaran : <br>
        RM 4,756,300.00 
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
        Kutipan : <br>
        RM 3,431,352.68
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/baling-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">56.85%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Baling</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 20,977,670.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 11,924,853.49
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 mr3 dashboard-box" 
      :use-icon="false"
      image="/images/map/pendang-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">56.21%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Pendang</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 15,779,310.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 8,869,767.83
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box mb3 dashboard-box" 
      :use-icon="false"
      image="/images/map/pokok-sena-1.png"  
      width="50px"
      height="110px"
      text='' 
    >

      <template #header>
          <span class="dashboard-percentage"><i class="mr1 fal fa-chart-line"></i> <span class="dashboard-percentage-no">23.41%</span></span>
      </template>

      <template #title>
        <div class="dashboard-title">Pokok Sena</div> 
      </template>

      <template #subtitle>
        <div class="dashboard-subtitle mt1 mb2">Kutipan Hasil Keseluruhan Koding 
        <br>Kategori : <b class="dashboard-category">B</b> </div>
      </template>

      <w-tag color="" bg-color="white" class="">
        <w-icon class="mr2" sm>
          fal fa-search
        </w-icon>
          Anggaran : <br>
          RM 20,556,030.00
      </w-tag>

      <w-tag color="" bg-color="white" class="ml2">
        <w-icon class="mr2" sm>
          fal fa-dollar-sign
        </w-icon>
          Kutipan : <br>
          RM 4,812,951.24
      </w-tag>
    </z-dashboard-item>

    </w-flex>
    <!--/3row -->

  </zen-one>
</template>

<script>


import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs
},
  setup () {
    

    const doughnutChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['2020', '2021'],
        datasets: [
          {
            borderColor: "#7983ff",
            backgroundColor: "#8bb4fa",
            data: [64.74, 94.63]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const monthlyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Januari', 'Febuari', 'Mac', 'April', 'May', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'],
        datasets: [{
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }, {
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const daylyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Kota Setar', 'Kuala Muda', 'Kubang Pasu', 'Langkawi', 'Kulim', 'Sik', 'Yan', 'Padang Terap', 'Bandar Baharu', 'Baling', 'Pendang', 'Pokok Sena'],
        datasets: [{
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }, {
          label: "join",
          color: "#9cabff",
          borderColor: "#7983ff",
          backgroundColor: "#8bb4fa",
          borderWidth: "1",
          data: [110, 80, 125, 55, 95, 75, 90, 110, 80, 125, 55, 95]
        }]
      },
      options: { plugins: { legend: { display: false }, } }

    }
    
    const transactionmethoddaylyChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['Kaunter', 'Portal iBayaq', 'Aplikasi Mobile'],
        datasets: [
          {
            borderColor: "#7983ff",
            backgroundColor: "#8bb4fa",
            data: [1000, 2050, 3000]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }
  
    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}   
    }    

    return {
      doughnutChart,
      monthlyChart,
      transactionmethoddaylyChart,
      daylyChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
  showCard: false,
  params : {}
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
},
  mounted() {
    
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.l == 1){
      window.location.replace(window.location.pathname);
    }
}
}

</script>

<style>
.dashboard-box .w-image {
    background-size: contain;
}
.zdiimage {
    margin-right: 7px;
}
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}
.dashboard-percentage {
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 20px;
}
.dashboard-percentage-no {
    font-size: 20px;
}
.dashboard-more {
    position: absolute;
    right: 20px;
    top: 30px;
    color: #fff;
    background: #1f2248;
    padding: 3px 15px;
    border-radius: 5px;
    border: none;
}
</style>